import AvatarIcon from './icons/AvatarIcon';
import styles from './PersonAvatar.style';

class PersonAvatar extends React.Component {
  state = {
    error: null,
  };

  onError = (error) => {
    this.setState({ error });
  };

  getClassName() {
    const { classes, className } = this.props;

    return classnames(classes.root, className);
  }

  getDimensions() {
    const { size } = this.props;

    return {
      width: size,
      height: size,
    };
  }

  renderDefault() {
    return <AvatarIcon />;
  }

  renderLogo() {
    const { classes } = this.props;

    return (
      <img
        alt="person-avatar"
        className={classes.image}
        src={this.props.src}
        onError={this.onError}
      />
    );
  }

  renderInner() {
    const { error } = this.state;
    const { src } = this.props;

    if (error || !src) {
      return this.renderDefault();
    } else {
      return this.renderLogo();
    }
  }

  render() {
    const {
      src: _src,
      classes: _classes,
      size: _size,
      onClick,
      ...props
    } = this.props;

    return (
      <div
        {...props}
        className={this.getClassName()}
        style={this.getDimensions()}
        onClick={onClick}>
        {this.renderInner()}
      </div>
    );
  }
}

PersonAvatar.defaultProps = {
  size: 24,
};

PersonAvatar.propTypes = {
  src: PropTypes.string,
  size: PropTypes.number,
};

export default withStyles(styles)(PersonAvatar);
